<!--  -->
<template>
  <div class="cen">
    <dl class="navigation">
      <div class="dddiv">
        <div class="dd">1<span>户籍信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">2<span>户籍附件</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">3<span>房产信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd">4<span>学校信息</span></div>
      </div>
      <p></p>
      <div class="dddiv">
        <div class="dd li_special">5<span>提交信息</span></div>
      </div>
    </dl>
    <div v-if="pageshow == '0'">
      <van-form scroll-to-error>
        <div class="tle">
          <span>户籍信息</span>
        </div>
        <!-- 学生姓名 -->
        <van-field
          v-model="ruleForm1.name"
          name="学生姓名"
          label="学生姓名"
          placeholder="请输入学生姓名"
          input-align="right"
          :rules="rules.name"
          disabled
        />
        <!-- 身份证号 -->
        <van-field
          v-model="ruleForm1.idCard"
          name="身份证号"
          label="身份证号"
          placeholder="请输入身份证号"
          input-align="right"
          @blur="getInfo(ruleForm1.idCard)"
          :rules="rules.idCard"
          disabled
        />
        <!-- 性别 -->
        <van-field
          v-model="ruleForm1.gender"
          name="学生性别"
          label="学生性别"
          placeholder="请输入学生性别"
          input-align="right"
          disabled
        />
        <!-- 出生日期 -->
        <van-field
          v-model="ruleForm1.birthDate"
          name="出生日期"
          label="出生日期"
          placeholder="请输入出生日期"
          input-align="right"
          disabled
        />
        <!-- 民族 -->
        <van-field
          v-model="ruleForm1.nation"
          name="民族"
          label="民族"
          placeholder="示例：汉族"
          input-align="right"
          :rules="rules.nation"
          disabled
        />
        <!-- 是否有多胞胎同时入学 -->
        <van-field
          name="是否有多胞胎同时入学"
          label="是否有多胞胎同时入学"
          input-align="right"
          :rules="rules.istwins"
          disabled
        >
          <template #input>
            <span>{{ ruleForm1.istwins == "0" ? "是" : "否" }}</span>
            <!-- <van-radio-group
              disabled
              v-model="ruleForm1.istwins"
              direction="horizontal"
            >
              <van-radio name="0">是</van-radio>
              <van-radio name="1">否</van-radio>
            </van-radio-group> -->
          </template>
        </van-field>
        <!-- 学生与落户籍人关系 -->
        <van-field
          readonly
          clickable
          name="学生与落户籍人关系"
          :value="ruleForm1.yuanyin"
          label="学生与落户籍人关系"
          placeholder="请选择学生与落户籍人关系"
          :rules="rules.yuanyin"
          input-align="right"
          disabled
        />
        <!-- 原因 -->
        <van-field
          v-model="ruleForm1.yuanyin1"
          name="请输入原因"
          label="请输入原因"
          placeholder="请输入"
          input-align="right"
          :rules="rules.yuanyin1"
          v-if="ruleForm1.yuanyinid == '5'"
          disabled
        >
          <template #input>
            <input
              type="text"
              placeholder="请输入"
              v-model="ruleForm1.yuanyin1"
              class="duan"
              disabled
            />
          </template>
        </van-field>
        <!-- 学生户籍是否在本地 -->
        <van-field
          v-model="ruleForm1.ishjbd"
          name="学生户籍是否在本地"
          label="学生户籍是否在本地"
          input-align="right"
          :rules="rules.ishjbd"
          disabled
        >
          <template #input>
            <span>{{ ruleForm1.ishjbd == "0" ? "是" : "否" }}</span>
            <!-- <van-radio-group
              disabled
              v-model="ruleForm1.ishjbd"
              direction="horizontal"
            >
              <van-radio name="0">是</van-radio>
              <van-radio name="1">否</van-radio>
            </van-radio-group> -->
          </template>
        </van-field>
        <!-- 学生户籍地派出所 -->
        <van-field
          v-if="ruleForm1.ishjbd == '0'"
          readonly
          clickable
          name="学生户籍地派出所"
          :value="ruleForm1.hjpcs"
          label="学生户籍地派出所"
          placeholder="请选择学生户籍地派出所"
          :rules="rules.hjpcs"
          input-align="right"
          disabled
        />

        <!-- 有无居住证 -->
        <van-field
          name="有无居住证"
          label="有无居住证"
          input-align="right"
          :rules="rules.isjzz"
          v-if="ruleForm1.ishjbd == 1"
          disabled
        >
          <template #input>
            <span>{{ ruleForm1.isjzz == "0" ? "有" : "无" }}</span>
            <!-- <van-radio-group
              disabled
              v-model="ruleForm1.isjzz"
              direction="horizontal"
            >
              <van-radio name="0">有</van-radio>
              <van-radio name="1">无</van-radio>
            </van-radio-group> -->
          </template>
        </van-field>
        <!-- 居住证日期 -->
        <van-field
          v-if="ruleForm1.ishjbd == '1' && ruleForm1.isjzz == '0'"
          name="居住证有效期"
          label="居住证有效期"
          input-align="right"
          :value="ruleForm1.yesdate"
          :rules="rules.yesdate"
          readonly
          clickable
          placeholder="请选择居住证有效期"
          disabled
        >
        </van-field>

        <!-- 居住证上现居住地址 -->
        <van-field
          v-if="ruleForm1.ishjbd == '1' && ruleForm1.isjzz == '0'"
          v-model="ruleForm1.jzaddress"
          name="居住证上现居住地址"
          label="居住证上现居住地址"
          placeholder="请输入居住证上现居住地址"
          input-align="right"
          :rules="rules.jzaddress"
          disabled
        />
        <!-- 有无房产 -->
        <van-field
          name="有无房产"
          label="有无房产"
          input-align="right"
          :rules="rules.isfc"
          disabled
        >
          <template #input>
            <span>{{ ruleForm1.isfc == "0" ? "有" : "无" }}</span>
            <!-- <van-radio-group
              disabled
              v-model="ruleForm1.isfc"
              direction="horizontal"
            >
              <van-radio name="0">有</van-radio>
              <van-radio name="2">无</van-radio>
            </van-radio-group> -->
          </template>
        </van-field>
        <!-- 居住证上现居住地址 -->
        <van-field
          v-model="ruleForm1.hjszd"
          name="户籍详细住址"
          label="户籍详细住址"
          placeholder="请输入户籍详细住址"
          input-align="right"
          :rules="rules.hjszd"
          disabled
        />
        <!--  现居住详细地址 -->
        <van-field
          v-model="ruleForm1.detailedAddress"
          name="现居住详细地址"
          label="现居住详细地址"
          placeholder="请输入现居住详细地址"
          input-align="right"
          :rules="rules.detailedAddress"
          disabled
        />
        <!-- 温馨提示 -->
        <div class="wxts">
          温馨提示：未成年人的父母是法定监护人。如未成年人父母死亡或没有监护能力的，依次由祖父母和外祖父母等担任监护人。
        </div>
        <!--  监护人(一)姓名 -->
        <van-field
          v-model="ruleForm1.firstGuardianName"
          name="监护人(一)姓名"
          label="监护人(一)姓名"
          placeholder="请输入监护人(一)姓名"
          input-align="right"
          :rules="rules.firstGuardianName"
          disabled
        />
        <!-- 监护人(一)证件类型 -->
        <van-field
          readonly
          clickable
          name="监护人(一)证件类型"
          :value="ruleForm1.firstGuardianIdcardType"
          label="监护人(一)证件类型"
          placeholder="请选择证件类型"
          :rules="rules.firstGuardianIdcardType"
          input-align="right"
          disabled
        />
        <!--  监护人(一)证件号码 -->
        <van-field
          v-model="ruleForm1.firstGuardianIdcard"
          name="监护人(一)证件号码"
          label="监护人(一)证件号码"
          placeholder="请输入监护人(一)证件号码"
          input-align="right"
          :rules="
            ruleForm1.firstGuardianIdcardTypeid == 0
              ? rules.firstGuardianIdcard
              : rules.firstGuardianIdcard1
          "
          disabled
        />
        <!-- 监护人(一)关系 -->
        <van-field
          readonly
          clickable
          name="监护人(一)关系"
          :value="ruleForm1.firstGuardianRelationship"
          label="监护人(一)关系"
          placeholder="请选择监护人(一)关系"
          :rules="rules.firstGuardianRelationship"
          input-align="right"
          disabled
        />
        <!--  监护人(一)联系电话 -->
        <van-field
          v-model="ruleForm1.firstGuardianPhone"
          name="监护人(一)联系电话"
          label="监护人(一)联系电话"
          placeholder="请输入监护人(一)联系电话"
          input-align="right"
          :rules="rules.firstGuardianPhone"
          disabled
        />
        <div class="bgdiv"></div>
        <!--  监护人(二)姓名 -->
        <van-field
          v-model="ruleForm1.secondGuardianName"
          name="监护人(二)姓名"
          label="监护人(二)姓名"
          placeholder="非必填"
          input-align="right"
          disabled
        />
        <!-- 监护人(二)证件类型 -->
        <van-field
          readonly
          clickable
          name="监护人(二)证件类型"
          :value="ruleForm1.secondGuardianIdcardType"
          label="监护人(二)证件类型"
          placeholder="非必填"
          input-align="right"
          disabled
        />
        <!--  监护人(二)证件号码 -->
        <van-field
          v-model="ruleForm1.secondGuardianIdcard"
          name="监护人(二)证件号码"
          label="监护人(二)证件号码"
          placeholder="非必填"
          input-align="right"
          @blur="getInfo1(ruleForm1.secondGuardianIdcard, 1)"
          disabled
        />
        <!-- 监护人(二)关系 -->
        <van-field
          readonly
          clickable
          name="监护人(二)关系"
          :value="ruleForm1.secondGuardianRelationship"
          label="监护人(二)关系"
          placeholder="非必填"
          input-align="right"
          disabled
        />
        <!--  监护人(二)联系电话 -->
        <van-field
          v-model="ruleForm1.secondGuardianPhone"
          name="监护人(二)联系电话"
          label="监护人(二)联系电话"
          placeholder="非必填"
          input-align="right"
          disabled
        />
        <div class="bgdiv"></div>
      </van-form>
      <van-form scroll-to-error>
        <div class="tle">
          <span>户籍附件</span>
        </div>
        <!-- 监护人(一)正反面身份证 -->
        <van-field
          name="uploader"
          label="监护人(一)正反面身份证"
          :rules="rules.upimg1"
          class="twoimg"
          disabled
        >
          <template #input>
            <div class="tupian">
              <img width="100%" :src="upimage + ruleForm2.upimg1" alt="" />
              <img width="100%" :src="upimage + ruleForm2.upimg2" alt="" />
            </div>
          </template>
        </van-field>
        <!-- 监护人(二)正反面身份证 -->
        <van-field
          class="twoimg"
          name="uploader"
          label="监护人(二)正反面身份证"
          v-if="ruleForm2.upimg3 || ruleForm2.upimg4"
          disabled
        >
          <template #input>
            <img
              width="100%"
              v-if="ruleForm2.upimg3"
              :src="upimage + ruleForm2.upimg3"
              alt=""
            />
            <img
              width="100%"
              v-if="ruleForm2.upimg4"
              :src="upimage + ruleForm2.upimg4"
              alt=""
            />
          </template>
        </van-field>
        <!-- 父亲户口页 -->
        <van-field
          name="uploader"
          label="父亲户口页"
          v-if="ruleForm1.yuanyinid == '0' || ruleForm1.yuanyinid == '1'"
          :rules="rules.upimg16"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg16" alt="" />
          </template>
        </van-field>
        <!-- 母亲户口页-->
        <van-field
          name="uploader"
          label="母亲户口页"
          v-if="ruleForm1.yuanyinid == '0' || ruleForm1.yuanyinid == '2'"
          :rules="rules.upimg17"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg17" alt="" />
          </template>
        </van-field>
        <!-- （外）祖父母户口页-->
        <van-field
          name="uploader"
          label="（外）祖父母户口页"
          v-if="ruleForm1.yuanyinid == '4'"
          :rules="rules.upimg18"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg18" alt="" />
          </template>
        </van-field>
        <!-- 其他证明-->
        <van-field
          name="uploader"
          label="其他证明"
          v-if="ruleForm1.yuanyinid == '5'"
          :rules="rules.upimg19"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg19" alt="" />
          </template>
        </van-field>
        <!-- 学生所在户口本首页-->
        <van-field
          name="uploader"
          label="学生所在户口本首页"
          :rules="rules.upimg20"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg20" alt="" />
          </template>
        </van-field>
        <!-- 户主页-->
        <van-field
          class="twoimg"
          name="uploader"
          label="户主页"
          :rules="rules.upimg6"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg6" alt="" />
          </template>
        </van-field>
        <!-- 学生户口页-->
        <van-field
          class="twoimg"
          name="uploader"
          label="学生户口页"
          :rules="rules.upimg9"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg9" alt="" />
          </template>
        </van-field>
        <!-- 出生证明-->
        <van-field
          class="twoimg"
          name="uploader"
          label="出生证明"
          :rules="rules.upimg10"
          v-if="ruleForm2.upimg10"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg10" alt="" />
          </template>
        </van-field>
        <!-- 居住证照片-->
        <van-field
          name="uploader"
          label="居住证照片"
          :rules="rules.upimg11"
          v-if="ruleForm1.isjzz == '0'"
          class="twoimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm2.upimg11" alt="" />
          </template>
        </van-field>
      </van-form>
      <van-form scroll-to-error>
        <div class="tle">
          <span>房产信息</span>
        </div>
        <!-- 房屋所有权人 -->
        <van-field
          v-model="ruleForm3.name"
          name="房屋所有权人"
          label="房屋所有权人"
          placeholder="请输入"
          input-align="right"
          :rules="rules.name"
          disabled
        />
        <!-- 房屋所有权人身份证号 -->
        <van-field
          v-model="ruleForm3.idno"
          name="房屋所有权人身份证号"
          label="房屋所有权人身份证号"
          placeholder="请输入"
          input-align="right"
          :rules="rules.idno"
          disabled
        />
        <!-- 房屋所有人关系 -->
        <van-field
          readonly
          clickable
          name="房屋所有人关系"
          :value="ruleForm3.relationship"
          label="房屋所有人关系"
          placeholder="请选择房屋所有人关系"
          :rules="rules.relationship"
          input-align="right"
          disabled
        />

        <!-- 是否与祖辈在同一户籍  -->
        <van-field
          v-if="ruleForm3.relationshipid == 4"
          name="是否与祖辈在同一户籍 "
          label="是否与祖辈在同一户籍 "
          input-align="right"
          :rules="rules.iszbtyhj"
          disabled
        >
          <template #input>
            <span>{{ ruleForm3.iszbtyhj == "0" ? "是" : "否" }}</span>
            <!-- <van-radio-group
              v-model="ruleForm3.iszbtyhj"
              direction="horizontal"
              disabled
            >
              <van-radio name="0">是</van-radio>
              <van-radio name="1">否</van-radio>
            </van-radio-group> -->
          </template>
        </van-field>
        <!-- 房产登记时间 -->
        <van-field
          name="房产登记时间"
          label="房产登记时间"
          input-align="right"
          :value="ruleForm3.djtime"
          :rules="rules.djtime"
          readonly
          clickable
          placeholder="请选择房产登记时间"
          disabled
        >
        </van-field>

        <!-- 房屋坐落 -->
        <van-field
          v-model="ruleForm3.address"
          name="房屋坐落"
          label="房屋坐落"
          placeholder="请输入"
          input-align="right"
          :rules="rules.address"
          disabled
        />
        <!-- 房屋具体位置 -->
        <van-field
          v-model="ruleForm3.address1"
          name="房屋具体位置"
          label="房屋具体位置"
          placeholder="请输入"
          input-align="right"
          :rules="rules.address1"
          disabled
        />
        <!-- 房产类型 -->
        <van-field
          readonly
          clickable
          name="房产类型"
          :value="ruleForm3.type"
          label="房产类型"
          placeholder="请选择房产类型"
          :rules="rules.type"
          input-align="right"
          disabled
        />

        <!-- A房产编号 -->
        <van-field
          v-if="ruleForm3.typeid == 'A'"
          v-model="ruleForm3.fcid1"
          name="房产编号"
          label="房产编号"
          placeholder="请输入"
          input-align="right"
          :rules="rules.fcid1"
          class="fcbh"
          disabled
        >
          <template #input>
            <span>梅 房权证 梅河口市 字第</span>
            <input
              type="text"
              placeholder="请输入"
              v-model="ruleForm3.fcid1"
              class="duan"
              disabled
            />
            <span>号</span>
          </template>
        </van-field>
        <!-- B房产编号 -->
        <van-field
          v-if="ruleForm3.typeid == 'B'"
          v-model="ruleForm3.fcid2"
          name="房产编号"
          label="房产编号"
          placeholder="请输入"
          input-align="right"
          :rules="rules.fcid2"
          class="fcbh"
          disabled
        >
          <template #input>
            <span>吉(</span>
            <input
              type="text"
              placeholder="请输入"
              v-model="ruleForm3.fcid1"
              class="duan"
              disabled
            />
            <span>)梅河口市 不动产权第</span>
            <input
              type="text"
              placeholder="请输入"
              v-model="ruleForm3.fcid2"
              class="duan"
              disabled
            />
            <span>号</span>
          </template>
        </van-field>
        <!-- C  -->
        <!-- 发票金额 -->
        <van-field
          v-if="ruleForm3.typeid == 'C'"
          v-model="ruleForm3.Invoicemoney"
          name="发票金额"
          label="发票金额"
          placeholder="请输入"
          input-align="right"
          :rules="rules.Invoicemoney"
          disabled
        />
        <!-- 合同签订时间 -->
        <van-field
          v-if="ruleForm3.typeid == 'C'"
          name="合同签订时间"
          label="合同签订时间"
          input-align="right"
          :value="ruleForm3.htqdtime"
          :rules="rules.htqdtime"
          readonly
          clickable
          disabled
          placeholder="请选择合同签订时间"
        >
        </van-field>

        <!-- 发票代码 -->
        <van-field
          v-if="ruleForm3.typeid == 'C'"
          v-model="ruleForm3.Invoicedm"
          name="发票代码"
          label="发票代码"
          placeholder="请输入"
          input-align="right"
          :rules="rules.Invoicedm"
          disabled
        />
        <!-- 发票号码 -->
        <van-field
          v-if="ruleForm3.typeid == 'C'"
          v-model="ruleForm3.Invoicehm"
          name="发票号码"
          label="发票号码"
          placeholder="请输入"
          input-align="right"
          :rules="rules.Invoicehm"
          disabled
        />
        <!-- D E -->
        <!-- 产权人 -->
        <van-field
          v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
          v-model="ruleForm3.cqname"
          name="产权人"
          label="产权人"
          placeholder="请输入"
          input-align="right"
          :rules="rules.cqname"
          disabled
        />
        <!-- 签订时间-->
        <van-field
          v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
          name="签订时间"
          label="签订时间"
          input-align="right"
          :value="ruleForm3.qdtime"
          :rules="rules.qdtime"
          readonly
          clickable
          placeholder="请选择签订时间"
          disabled
        >
        </van-field>

        <!-- 协议书编号 -->
        <van-field
          v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
          v-model="ruleForm3.xqsid"
          name="协议书编号"
          label="协议书编号"
          placeholder="请输入"
          input-align="right"
          :rules="rules.xqsid"
          disabled
        />
        <!-- 差额票据 -->
        <van-field
          v-if="ruleForm3.typeid == 'D' || ruleForm3.typeid == 'E'"
          v-model="ruleForm3.bill"
          name="差额票据"
          label="差额票据"
          placeholder="请输入"
          input-align="right"
          :rules="rules.bill"
          disabled
        />
        <!-- F1 F2 G1 G2 -->
        <!-- 协议签订时间-->
        <van-field
          v-if="
            ruleForm3.typeid == 'F1' ||
            ruleForm3.typeid == 'F2' ||
            ruleForm3.typeid == 'G1' ||
            ruleForm3.typeid == 'G2'
          "
          name="协议签订时间"
          label="协议签订时间"
          input-align="right"
          :value="ruleForm3.xyqdtime"
          :rules="rules.xyqdtime"
          readonly
          clickable
          placeholder="请选择签订时间"
          disabled
        >
        </van-field>

        <!-- 房产类型证明-->
        <van-field
          class="tupian twoimg"
          name="uploader"
          label="房产类型证明"
          :rules="rules.htimg"
          disabled
        >
          <template #input>
            <img width="100%" :src="upimage + ruleForm3.htimg" alt="" />
          </template>
        </van-field>
      </van-form>
      <van-form @submit="next" scroll-to-error>
        <div class="tle">
          <span>学校信息</span>
        </div>
        <!-- 选择学段 -->
        <van-field
          readonly
          clickable
          name="选择学段"
          :value="ruleForm5.xueduan"
          label="选择学段"
          placeholder="请选择学段"
          :rules="rules.xueduan"
          input-align="right"
          disabled
        />

        <!-- 选择学校 -->
        <van-field
          readonly
          clickable
          name="选择学校"
          :value="ruleForm5.school"
          label="选择学校"
          placeholder="请选择学校"
          :rules="rules.schoolid"
          input-align="right"
          disabled
        />
        <!-- 提交按钮 -->
        <div style="margin: 0.64rem">
          <van-button class="btn" native-type="button" @click="back"
            >返回</van-button
          >
          <van-button class="btn" :loading="codeDisabled" native-type="submit"
            >提交</van-button
          >
        </div>
        <div class="bgdiv"></div>
      </van-form>
    </div>
    <div class="main2" v-else>
      <div class="img"><img src="../assets/images/pass.png" /></div>
      <div class="p1">
        <p>招生报名信息提交已成功！</p>
      </div>
      <div class="p2">
        <p>我们会尽快审核，请您随时关注本平台的审核信息</p>
      </div>
      <van-button class="btnq" @click="wancheng()">完成</van-button>
    </div>
    <notices></notices>
  </div>
</template>
      
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapGetters } from "vuex";
import "element-ui/lib/theme-chalk/index.css";
import {
  getpolice,
  getschool,
  selectone,
  selecttwo,
  selectthree,
  selectfour,
  savedata,
} from "@/api/news";
import notices from "../components/notices.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { notices },
  data() {
    //这里存放数据
    return {
      codeDisabled: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      upimage: process.env.VUE_APP_FILE_UPLOAD_URL,
      pageshow: "0", //0-提交页面 1-完成页面
      ruleForm1: {
        relationship: "", //学生和落户籍人关系 x
        isonehk: "", //学生和监护人是否在一个户口本
        ishjbd: "", //学生户籍是否在本地
        istwins: "", //是否是双胞胎
        isjzz: "", //有无居住证
        yuanyin: "", //原因（选择）
        yuanyinid: "", //原因（选择）id
        yuanyin1: "", //原因（输入）
        yesdate: "", //居住证有效期
        stardate: "", //居住证有效期开始时间
        enddate: "", //居住证有效期结束时间
        jzaddress: "", //居住证上现居住地址
        isfc: "", //有无房产
        hjpcs: "", //户籍派出所
        hjpcsid: "", //户籍派出所id
        hjszd: "", // 户籍详细住址
        loginUserId: "",
        householdId: "",
        checkInfoId: "",
        name: "", //姓名
        nation: "", //民族
        idCard: "", //身份证号
        special: "", //特殊优抚
        firstGuardianName: "", //监护人1姓名
        firstGuardianRelationship: "", //监护人1关系
        firstGuardianRelationshipid: "", //监护人1关系id
        firstGuardianIdcardType: "", //监护人1类型
        firstGuardianIdcardTypeid: "", //监护人1类型id
        firstGuardianIdcard: "", //监护人1身份证号
        firstGuardianPhone: "", //监护人1电话
        gender: "", //性别
        birthDate: "", //出生日期
        secondGuardianName: null, //监护人2姓名
        secondGuardianRelationship: null, //监护人2关系
        secondGuardianRelationshipid: null, //监护人2关系id
        secondGuardianIdcardType: null, //监护人2类型
        secondGuardianIdcardTypeid: null, //监护人2类型id
        secondGuardianIdcard: null, //监护人2身份证号
        secondGuardianPhone: null, //监护人2电话
        detailedAddress: "", //现居住详细地址
        mold: 2,
        step: 1,
      },
      ruleForm2: {
        id: "",
        upimg1: "", //监护人1正面
        upimg2: "", //监护人1反面
        upimg3: "", //监护人2正面
        upimg4: "", //监护人2反面
        upimg5: "", //结婚证
        upimg6: "", //户主页
        upimg7: "", //离婚证 x
        upimg8: "", //离婚协议 x
        upimg9: "", //学生户口页
        upimg10: "", //出生证明
        upimg11: "", //居住证照片
        upimg12: "", //特殊优抚 其他 证明信 x
        upimg13: "", //拆迁证明 x
        upimg14: "", //特殊优抚 哥哥或姐姐出生证明 x
        upimg15: "", //监护人户口页 x
        upimg16: "", //父亲户口页
        upimg17: "", //母亲户口页
        upimg18: "", //（外）祖父母户口页
        upimg19: "", //其他证明
        upimg20: "", //学生所在户口本首页
      },
      ruleForm3: {
        type: "", //类型 A.房屋所有权证 B.不动产权证书 C.商品房买卖合同 D.产权调换协议书 E.货币化安置合同 F.廉租房和住房补贴 G.租房户和二手房未过户
        name: "", //房屋所有权人
        relationship: "", //与学生关系
        relationshipid: "", //与学生关系id
        iszbtyhj: "", //是否与祖辈在同一户籍
        idno: "", //房屋所有权人身份证号
        djtime: "", //房产登记时间
        address: "", //房屋坐落（按房产证填写）
        address1: "", //房屋具体位置
        fcid: "", //房产编号
        fcid1: "", //房产编号1
        fcid2: "", //房产编号2
        Invoicemoney: "", //发票金额
        Invoicedm: "", //发票代码
        Invoicehm: "", //发票号码
        htqdtime: "", //合同签订时间
        cqname: "", //产权人
        qdtime: "", //签订时间
        xqsid: "", //协议书编号
        bill: "", //差额票据
        xyqdtime: "", //协议签订时间
        htimg: "", //合同证书
      },
      ruleForm5: {
        xueduan: "", //学段
        xdid: "", //学段id
        school: "", //学校
        schoolid: "", //学校id
        mold: 1,
        step: 5,
      },
      yylist: [
        {
          label: "父母和适龄儿童少年(在同一户口簿)",
          value: "0",
        },
        {
          label: "父亲(监护人)和适龄儿童少年",
          value: "1",
        },
        {
          label: "母亲(监护人)和适龄儿童少年",
          value: "2",
        },
        {
          label: "(外)祖父母、父母和适龄儿童少年",
          value: "3",
        },
        {
          label: "(外)祖父母和适龄儿童少年",
          value: "4",
        },
        { label: "其他", value: "5" },
      ],
      relationship: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "其他", value: "4" },
      ],
      relationships: [
        { label: "父子", value: "0" },
        { label: "母子", value: "1" },
        { label: "父女", value: "2" },
        { label: "母女", value: "3" },
        { label: "祖孙", value: "4" },
        { label: "其他", value: "5" },
        { label: "本人", value: "6" },
      ],
      type: [
        { label: "身份证", value: "0" },
        { label: "军官证", value: "1" },
      ],
      tlist: [],
      tlist1: [
        // 类型数组
        { label: "房屋所有权证", value: "A" },
        { label: "不动产权证书", value: "B" },
        { label: "商品房买卖合同", value: "C" },
        { label: "产权调换协议书", value: "D" },
        { label: "货币化安置合同", value: "E" },
        { label: "廉租房", value: "F1" },
        { label: "住房补贴", value: "F2" },
      ],
      tlist2: [
        // 类型数组
        { label: "租房", value: "G1" },
        { label: "二手房未过户", value: "G2" },
        { label: "其他", value: "H" },
      ],
      schoolType: [
        {
          name: "小学",
          id: "0",
        },
        {
          name: "初中",
          id: "1",
        },
      ],
      entranceTeams: [
        { label: "男", value: "0" },
        { label: "女", value: "1" },
      ],
      schoollist: [], //学校列表
      policelist: [], //派出所列表
      rules: {},
      bgimg: "",
      tjpan: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(["leftBtnClick", "rightBtnClick"]),
  },
  //监控data中的数据变化
  watch: {
    schoollist: {
      handler(newVal, oldVal) {
        // console.log("新值：", newVal);
        // console.log("旧值：", oldVal);
        if (this.policelist.length > 0) {
          console.log("读取1");
          this.pan();
        }
      },
      deep: true,
    },
    policelist: {
      handler(newVal, oldVal) {
        // console.log("新值：", newVal);
        // console.log("旧值：", oldVal);
        if (this.schoollist.length > 0) {
          console.log("读取2");
          this.pan();
        }
      },
      deep: true,
    },
    leftBtnClick(clickdic) {
      console.log(clickdic);
      this.$router.push({
        path: "/school",
      });
    },
    rightBtnClick(clickdic) {
      // console.log(clickdic);
      sessionStorage.setItem("from", JSON.stringify(this.from));
      this.$router.push({
        path: "/record",
      });
    },
  },
  created() {
    this.loading1 = true;
    this.loading2 = true;
    this.loading3 = true;
    this.loading4 = true;
    if (JSON.parse(sessionStorage.getItem("wancheng"))) {
      this.pageshow = JSON.parse(sessionStorage.getItem("wancheng"));
    }
    this.getschool();
    this.getpolice();
  },
  methods: {
    //用户须知公共弹窗
    tan() {
      this.$notice(true);
    },
    //判断显示读取缓存
    pan() {
      if (JSON.parse(sessionStorage.getItem("from1"))) {
        const s = JSON.parse(sessionStorage.getItem("from1"));
        console.log(s);
        this.ruleForm1 = s;
        if (this.ruleForm1.isfc == "0") {
          this.tlist = this.tlist1;
        } else {
          this.tlist = this.tlist2;
        }
        this.loading1 = false;
        // this.ruleForm1.yesdate = [];
        // this.ruleForm1.yesdate[0] = this.ruleForm1.stardate;
        // this.ruleForm1.yesdate[1] = this.ruleForm1.enddate;
      } else {
        this.selectone();
      }
      if (JSON.parse(sessionStorage.getItem("from2"))) {
        const s = JSON.parse(sessionStorage.getItem("from2"));
        this.ruleForm2 = s;
        this.loading2 = false;
      } else {
        this.selecttwo();
      }
      if (JSON.parse(sessionStorage.getItem("from3"))) {
        const s = JSON.parse(sessionStorage.getItem("from3"));
        this.ruleForm3 = s;
        this.loading3 = false;
      } else {
        this.selectthree();
      }
      if (JSON.parse(sessionStorage.getItem("from4"))) {
        const s = JSON.parse(sessionStorage.getItem("from4"));
        this.ruleForm5 = s;
        this.loading4 = false;
      } else {
        this.selectfour();
      }
    },
    //获取学校
    async getschool() {
      const res = await getschool();
      console.log(res);
      if (res.code == "200") {
        this.schoollist = res.data;
      } else {
        this.$toast("获取学校失败," + res.msg);
      }
    },
    //获取派出所
    async getpolice() {
      const res = await getpolice();
      console.log(res);
      if (res.code == "200") {
        this.policelist = res.data;
      } else {
        this.$toast("获取派出所," + res.msg);
      }
    },
    //提交
    async savedata() {
      this.codeDisabled = true;
      this.tjpan = 1;
      const res = await savedata({
        id: JSON.parse(sessionStorage.getItem("userInfoId")),
        type: "0", //登录类型 (0：手机  1：PC)
      });
      console.log(res);
      this.codeDisabled = false;
      this.tjpan = 0;
      if (res.code == "200") {
        this.$toast("提交成功");
        this.pageshow = 1;
        sessionStorage.setItem("wancheng", JSON.stringify(this.pageshow));
      } else {
        this.$toast("提交失败," + res.msg);
      }
    },
    wancheng() {
      this.$router.push({
        path: "/create",
        // query: { sign: 1 },
      });
    },
    disableBrowserBack() {
      history.pushState(null, null, document.URL);
    },
    back() {
      console.log(this.$route.query.houseId);
      this.$router.push({
        path: "/school",
        query: {},
      });
    },
    next() {
      if (this.tjpan == 0) {
        this.savedata();
      }
    },
    //查询返显one
    async selectone() {
      const res = await selectone({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.loading = false;
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm1.name = s.studentName; //学生姓名
        this.ruleForm1.idCard = s.studentIdcard; //学生身份证号
        this.ruleForm1.gender = s.studentGender == "0" ? "男" : "女"; //学生性别
        this.ruleForm1.nation = s.studentNation; //学生民族
        this.ruleForm1.birthDate = s.studentBirthday; //学生出生日期
        this.ruleForm1.yuanyinid = s.xsylhjrgx; //学生与落户籍人关系
        this.ruleForm1.yuanyin1 = s.xsylhjrgxyy; //学生与落户籍人关系原因
        this.ruleForm1.istwins = s.isTwins; //是否是双胞胎（1：是，2：否）
        this.ruleForm1.tname = s.twinName; //双胞胎姓名
        this.ruleForm1.tidno = s.twinIdcard; //双胞胎身份证号
        this.ruleForm1.isonehk = s.xshfmsfzyghkb; //学生和父母是否在一个户口本（1：是，2：否）
        this.ruleForm1.ishjbd = s.xshjsfzbd; //学生户籍是否在本地（1：是，2：否）
        this.ruleForm1.isfc = s.hasHouse; //有无房产
        this.ruleForm1.isjzz = s.hasResidencePermit; //有无居住证
        this.ruleForm1.yesdate = s.residencePermitLifespan; //居住证有效期
        // this.ruleForm1.stardate =
        //   this.ruleForm1.yesdate.length > 0 ? this.ruleForm1.yesdate[0] : ""; //居住证有效期开始时间
        // this.ruleForm1.enddate =
        //   this.ruleForm1.yesdate.length > 1 ? this.ruleForm1.yesdate[1] : ""; //居住证有效期结束时间
        this.ruleForm1.jzaddress = s.residencePermitAddress; //居住证上现居住地址
        this.ruleForm1.hjpcsid = s.studentDomicilePolice; //学生户籍地派出所
        this.ruleForm1.hjszd = s.domicileAddress; //户籍详细地址
        this.ruleForm1.detailedAddress = s.nowAddress; //现居住详细地址
        this.ruleForm1.special = s.tsyf; //特殊优抚
        this.ruleForm1.geigeiname = s.ggjjname; //哥哥/姐姐姓名
        this.ruleForm1.geigeiidno = s.ggjjidcard; //哥哥/姐姐身份证号
        this.ruleForm1.ggschool = s.ggjjschool; //哥哥/姐姐学校
        this.ruleForm1.ggclass = s.ggjjgrade; //哥哥/姐姐年级
        this.ruleForm1.isgghkb = s.sfyggjjzyghkb; //是否和哥哥姐姐在同一个户口本
        this.ruleForm1.firstGuardianName = s.guardionOneName; //监护人（一）姓名
        this.ruleForm1.firstGuardianRelationshipid = s.guardionOneRelation; //监护人（一）关系
        this.ruleForm1.firstGuardianIdcardTypeid = s.guardionOneDocumentType; //监护人（一）证件类型
        this.ruleForm1.firstGuardianIdcard = s.guardionOneDocumentNumber; //监护人（一）证件号码
        this.ruleForm1.firstGuardianPhone = s.guardionOneDocumentPhone; //监护人（一）联系电话
        this.ruleForm1.secondGuardianName = s.guardionTwoName; //监护人（二）姓名
        this.ruleForm1.secondGuardianRelationshipid = s.guardionTwoRelation; //监护人（二）关系
        this.ruleForm1.secondGuardianIdcardTypeid = s.guardionTwoDocumentType; //监护人（二）证件类型
        this.ruleForm1.secondGuardianIdcard = s.guardionTwoDocumentNumber; //监护人（二）证件号码
        this.ruleForm1.secondGuardianPhone = s.guardionTwoDocumentPhone; //监护人（二）联系电话
        this.yylist.forEach((e) => {
          if (e.value == this.ruleForm1.yuanyinid) {
            this.ruleForm1.yuanyin = e.label;
          }
        });
        this.policelist.forEach((e) => {
          if (e.id == this.ruleForm1.hjpcsid) {
            this.ruleForm1.hjpcs = e.name;
          }
        });
        this.type.forEach((e) => {
          if (e.value == this.ruleForm1.firstGuardianIdcardTypeid) {
            this.ruleForm1.firstGuardianIdcardType = e.label;
          }
        });
        this.relationship.forEach((e) => {
          if (e.value == this.ruleForm1.firstGuardianRelationshipid) {
            this.ruleForm1.firstGuardianRelationship = e.label;
          }
        });
        this.type.forEach((e) => {
          if (e.value == this.ruleForm1.secondGuardianIdcardTypeid) {
            this.ruleForm1.secondGuardianIdcardType = e.label;
          }
        });
        this.relationship.forEach((e) => {
          if (e.value == this.ruleForm1.secondGuardianRelationshipid) {
            this.ruleForm1.secondGuardianRelationship = e.label;
          }
        });
        sessionStorage.setItem("from1", JSON.stringify(this.ruleForm1));
        sessionStorage.setItem("oneid", JSON.stringify(res.data.id));
      } else {
        this.$toast(res.msg);
      }
    },
    //查询返显two
    async selecttwo() {
      const res = await selecttwo({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm2.upimg1 = s.guardianOneIdcardFrontPath; //监护人1正面
        this.ruleForm2.upimg2 = s.guardianOneIdcardBackPath; //监护人1反面
        this.ruleForm2.upimg3 = s.guardianTwoIdcardFrontPath; //监护人2正面
        this.ruleForm2.upimg4 = s.guardianTwoIdcardBackPath; //监护人2反面
        this.ruleForm2.upimg5 = s.marriageCertificatePath; //结婚证
        this.ruleForm2.upimg6 = s.householdPagePath; //户主页
        this.ruleForm2.upimg7 = s.divorceCertificatePath; //离婚证
        this.ruleForm2.upimg8 = s.divorceAgreementPath; //离婚协议
        this.ruleForm2.upimg9 = s.studentPagePath; //学生户口页
        this.ruleForm2.upimg10 = s.birthCertificatePath; //出生证明
        this.ruleForm2.upimg11 = s.residencePermitPath; //居住证照片
        this.ruleForm2.upimg16 = s.fatherPagePath; //父亲户口页
        this.ruleForm2.upimg17 = s.motherPagePath; //母亲户口页
        this.ruleForm2.upimg18 = s.zfmhkyPath; //（外）祖父母户口页
        this.ruleForm2.upimg19 = s.otherProofPath; //其他证明
        this.ruleForm2.upimg20 = s.xsszhkbsyPath; //学生所在户口本首页

        // sessionStorage.setItem("imgstaus", JSON.stringify(this.imgstaus));
        // sessionStorage.setItem("from2", JSON.stringify(this.ruleForm2));
        // sessionStorage.setItem("twoid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显three
    async selectthree() {
      const res = await selectthree({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm3.typeid = s.hourseType; //类型 A.房屋所有权证 B.不动产权证书 C.商品房买卖合同 D.产权调换协议书 E.货币化安置合同 F.廉租房和住房补贴 G.租房户和二手房未过户
        this.ruleForm3.name = s.propertyOwnerName; //房屋所有权人
        this.ruleForm3.relationshipid = s.propertyOwnerRelation; //与学生关系
        this.ruleForm3.iszbtyhj = s.sfyzbztyhj; //与祖辈是否在同一户籍
        this.ruleForm3.idno = s.propertyOwnerIdcard; //房屋所有权人身份证号
        this.ruleForm3.djtime = s.realEstateRegTime; //房产登记时间
        this.ruleForm3.address = s.hourseLocalcation; //房屋坐落（按房产证填写）
        this.ruleForm3.address1 = s.hourseAddress; //房屋具体位置
        this.ruleForm3.fcid = s.hourseNumber; //房产编号
        this.ruleForm3.Invoicemoney = s.invoiceAmount; //发票金额
        this.ruleForm3.Invoicedm = s.invoiceCode; //发票代码
        this.ruleForm3.Invoicehm = s.invoiceNumber; //发票号码
        this.ruleForm3.htqdtime = s.contractSignTime; //合同签订时间
        this.ruleForm3.cqname = s.propertyOwner; //产权人
        this.ruleForm3.qdtime = s.signTime; //签订时间
        this.ruleForm3.xqsid = s.agreementNumber; //协议书编号
        this.ruleForm3.bill = s.differentialBill; //差额票据
        this.ruleForm3.xyqdtime = s.agreementSignTime; //协议签订时间
        this.ruleForm3.htimg = s.housingOwnershipPath; //合同证书
        if (this.ruleForm1.isfc == "0") {
          if (this.ruleForm3.typeid == "G1" || this.ruleForm3.typeid == "G2") {
            this.ruleForm3.type = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        } else if (this.ruleForm1.isfc == "2") {
          if (this.ruleForm3.typeid != "G1" && this.ruleForm3.typeid != "G2") {
            this.ruleForm3.type = "";
            this.ruleForm3.typeid = "";
            this.ruleForm3.htimg = "";
            this.imgstaus.fileList = [];
            this.imgstaus.upimg = false;
          }
        }
        if (this.ruleForm3.typeid == "A") {
          const str = this.ruleForm3.fcid;
          const indexs = str.indexOf("第");
          const str1 = str.substring(indexs + 1, str.length);
          const index = str1.indexOf("号");
          const resolve = str1.substring(0, index);
          console.log(resolve);
          this.ruleForm3.fcid1 = resolve;
        } else if (this.ruleForm3.typeid == "B") {
          const a = this.ruleForm3.fcid;
          const i = a.indexOf("（");
          const b = a.substring(i + 1, a.length);
          const i1 = b.indexOf("）");
          const resolve = b.substring(0, i1);
          console.log(resolve);
          this.ruleForm3.fcid1 = resolve;
          const i2 = a.indexOf("第");
          const c = a.substring(i2 + 1, a.length);
          const i3 = c.indexOf("号");
          const resolve1 = c.substring(0, i3);
          console.log(resolve1);
          this.ruleForm3.fcid2 = resolve1;
        }
        this.relationships.forEach((e) => {
          if (e.value == this.ruleForm3.relationshipid) {
            this.ruleForm3.relationship = e.label;
          }
        });
        this.tlist.forEach((e) => {
          if (e.value == this.ruleForm3.typeid) {
            this.ruleForm3.type = e.label;
          }
        });
        // sessionStorage.setItem("from3", JSON.stringify(this.ruleForm3));
        // sessionStorage.setItem("fcimgstaus", JSON.stringify(this.imgstaus));
        // sessionStorage.setItem("threeid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
    //查询返显four
    async selectfour() {
      const res = await selectfour({
        userInfoId: JSON.parse(sessionStorage.getItem("userInfoId")), //报名id
      });
      console.log(res);
      this.cha2 = 1;
      if (this.cha1 == "1" && this.cha2 == "1") {
        this.loading = false;
      }
      if (res.code == "200") {
        const s = res.data;
        this.ruleForm5.xdid = s.academicStage; //学段
        this.xzxueduan(this.ruleForm5.xdid);
        console.log(this.ruleForm5.schoolid);
        this.ruleForm5.schoolid = s.schoolId; //学校id
        this.schoolType.forEach((e) => {
          if (e.id == this.ruleForm5.xdid) {
            this.ruleForm5.xueduan = e.name; //学校id
          }
        });
        this.schoollist.forEach((e) => {
          if (e.id == this.ruleForm5.schoolid) {
            this.ruleForm5.school = e.schoolName; //学校id
          }
        });
        sessionStorage.setItem("from4", JSON.stringify(this.ruleForm5));
        sessionStorage.setItem("fourid", JSON.stringify(res.data.id));
      } else {
        this.$toast("查询失败," + res.msg);
      }
    },
  },
  mounted() {
    // 禁用浏览器返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
  },
  destroyed() {
    // 清除popstate事件 否则会影响到其他页面
    window.removeEventListener("popstate", this.disableBrowserBack, false);
    sessionStorage.removeItem("wancheng");
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
/*@import url(); 引入公共css类*/
.cen {
  width: 100%;
}
.tle {
  background-color: #f2f6f7;
  font-size: 0.48rem;
  height: 1.2rem;
  line-height: 1.2rem;
  text-align: left;
  display: flex;
  align-items: center;
  padding-left: 0.5rem;
  span {
    display: block;
    border-left: 0.2rem solid #0f9386;
    height: 0.72rem;
    line-height: 0.72rem;
    padding-left: 0.2rem;
  }
}
.navigation {
  width: 90%;
  height: 1.5rem;
  margin: 1.5rem auto;
  margin-bottom: 2.2rem;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.navigation p {
  width: 1.2rem;
  height: 0.04rem;
  background: #b2dcd8;
  position: relative;
  border: 0.04rem dashed #fff;
  top: -0.2rem;
}
.navigation .dddiv {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 2.4rem;
  border: 0.04rem dashed #0f9386;
  display: flex;
  align-items: center;
  justify-content: center;
}
.navigation .dd {
  width: 1.2rem;
  height: 1.2rem;
  text-align: center;
  line-height: 1.2rem;
  background: #b2dcd8;
  border-radius: 0.6rem;
  font-size: 0.52rem;
  color: #fff;
  border: 0.04rem solid #fff;
  position: relative;
}
.navigation .dd span {
  display: block;
  width: 2rem;
  height: auto;
  position: absolute;
  top: 1.5rem;
  left: -0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.48rem;
  color: #ccc;
  letter-spacing: 0.006rem;
}
.navigation .li_special {
  background: #0f9386;
}
.navigation .li_special span {
  color: #000;
}
.btn {
  width: 4.8rem;
  background: #0f9386;
  color: #fff;
  margin-left: 1rem;
  border-radius: 0.2rem;
}
.wxts {
  background: #f2f6f7;
  font-size: 0.52rem;
  padding: 0.4rem;
  color: red;
  text-align: justify;
}
.bgdiv {
  background: #f2f6f7;
  height: 0.4rem;
}
.btn {
  width: 4.5rem;
  background: #0f9386;
  color: #fff;
  margin-left: 1rem;
  border-radius: 0.2rem;
}
/deep/.van-field__label {
  width: 6rem;
}
/deep/.van-field__error-message {
  text-align: right;
}
.duan {
  text-align: end;
  border: none;
  background: #fff;
  color: #000;
}
.tupian {
  display: flex;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  img {
    width: 3rem;
    height: 3rem;
    margin-right: 0.3rem;
    margin-top: 1rem;
  }
  span {
    margin-top: 0.5rem;
    font-size: 0.48rem;
    color: red;
  }
}
.twoimg {
  display: flex;
  flex-direction: column;
  /deep/.van-field__label {
    width: 10rem;
  }
  img {
    width: 3rem;
    height: 3rem;
    margin-right: 0.3rem;
    margin-top: 1rem;
  }
}
.main2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 0.64rem;
  margin-top: 8rem;
  img {
    width: 2rem;
  }
  .btnq {
    width: 8rem;
    background-color: #0f9386;
    color: #fff;
    margin-top: 1rem;
  }
}
.duan {
  width: 2rem;
  border: none;
}
.tupian {
  display: flex;
  //   flex-direction: column;
}
/deep/.van-field__label {
  width: 6rem;
}
/deep/.van-field__control--custom {
  margin-top: 0.2rem;
}
.fcbh {
  font-size: 0.48rem;
  /deep/.van-field__label {
    width: 3rem;
  }
}
.van-cell {
  font-size: 0.48rem;
}
/deep/.van-field__control:disabled {
  color: #000;
  -webkit-text-fill-color: #000;
}
</style>